<template>
    <div class="page">
        <div class="niubi-detail">
            <div class="title">
                <span>交易明细</span>
                <img class="down-arrow" src="~@/assets/left-arrow.png" alt="" />
            </div>
            <div class="list">
                <div class="item" v-for="item in list" :key="item.id">
                    <div class="left">
                        <div class="sub-title">{{ item.gift_name }}</div>
                        <div class="time">{{ item.create_time }}</div>
                    </div>
                    <div
                        class="right"
                        :class="[item.pay_gold > 0 ? 'add' : 'reduce']"
                    >
                        {{ item.pay_gold }}
                    </div>
                </div>
            </div>
        </div>
        <no-content :msg="'暂无明细'" v-if="showNoContent"></no-content>
    </div>
</template>

<script>
import userCenterService from "../../service/user-center.service";
import noContent from "../../components/no-content/no-content";
export default {
    name: "recharge",
    components: {
        "no-content": noContent
    },
    data() {
        return {
            isShowRechage: false,
            list: [],
            showNoContent: false
        };
    },
    mounted() {
        this.getPayList();
    },
    methods: {
        close() {
            this.isShowRechage = false;
        },
        showRecharge() {
            this.isShowRechage = true;
        },
        getPayList() {
            userCenterService.payList().then(res => {
                this.list = res.data;
                if (this.list.length <= 0) {
                    this.showNoContent = true;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped src="./recharge.scss">
</style>